import { useCallback } from 'react'
import { type NodeEntry, type Range } from 'slate'

export type Decorator = (entry: NodeEntry) => Range[]

export function useDecorations(decorators: Decorator[]) {
  return useCallback(
    (entry: NodeEntry) => decorators.flatMap((decorator) => decorator(entry)),
    [decorators],
  )
}
